var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
var Shell = function (_a) {
    var className = _a.className, _b = _a.as, as = _b === void 0 ? 'div' : _b, props = __rest(_a, ["className", "as"]);
    var Tag = as;
    return React.createElement(Tag, __assign({ className: classNames("overflow-hidden rounded-lg bg-white border shadow", className) }, props));
};
var Body = function (_a) {
    var className = _a.className, _b = _a.as, as = _b === void 0 ? 'div' : _b, interactable = _a.interactable, props = __rest(_a, ["className", "as", "interactable"]);
    var Tag = as;
    return React.createElement(Tag, __assign({ className: classNames("p-4 w-full text-left", className, { "focus:bg-gray-50 hover:bg-gray-50 active:bg-gray-100": interactable }) }, props));
};
var Card = function (_a) {
    var className = _a.className, children = _a.children, props = __rest(_a, ["className", "children"]);
    return React.createElement(Shell, __assign({ className: className }, props),
        React.createElement(Body, null, children));
};
Card.Shell = Shell;
Card.Body = Body;
export { Card };
